import type { FolderPopulated } from "@vita-learning/types";

import { decodeHtml } from "~/shared/utils";

export const decodeFolder = ({
	title,
	...folder
}: FolderPopulated): FolderPopulated => ({
	title: decodeHtml(title),
	...folder,
});
